<div *ngIf="winners.length" class="winners-bar">
  <div class="winners-scroll-container">
    <div
      class="winners-scroll-content"
      [style.animation-duration.s]="winners.length * 4"
    >
      <span *ngFor="let winner of tickerItems" class="winners-scroll-item">
        <span class="winners-scroll-icon">🏆</span>
        <span class="winners-scroll-highlight">{{ winner.userName }}</span>
        <span class="winners-scroll-text"
          >WON {{ winner.score | currency: "USD" : "symbol" : "1.0-2" }}</span
        >
      </span>
    </div>
  </div>
</div>
